/**
 * BackgroundManager.js
 * Creates bubbles
 */

import { Game, GameScene, GameSprite, DesignDataTypes } from "pixi_core";
import { SceneLayers } from "../Constants";
export class BackgroundManager {
    /**
     * @public
     * @param {GameScene} scene
     */
    constructor(scene) {
        /** @private @type {GameScene} */
        this._scene = scene;

        /** @private @type {GameSprite} */
        this._backgroundImage = null;
    }

    /**
     * @public
     * @param {Number} act
     */
    addBackgroundImage(act) {
        let backgroundName = "BGD_Background0" + act.toString();
        let backgroundData = Game.design.getData(backgroundName, DesignDataTypes.eGRAPHIC);
        this._backgroundImage = new GameSprite(backgroundData.asset);
        this._scene.addChild(this._backgroundImage, SceneLayers.eBACKGROUND);
    }

    /**
     * @public
     */
    destroy() {
        this._backgroundImage.destroy();
        this._backgroundImage = null;
    }
}
